import axios from "axios";
import { createHashHistory } from "history";


import { logout } from "./Authentication";

const history = createHashHistory();

const headers = {
  "Content-Type": "application/json",
};

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers,
  // Autenticação via cookie httpOnly 'token' (emitido pelo back no login) —
  // o navegador manda ele sozinho em toda requisição. Nenhum JS aqui lê ou
  // monta o token; é o que protege a sessão contra roubo via XSS.
  withCredentials: true,
});

API.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    const { data } = error?.response;

    if (
      error.response &&
      error.response.status === 401 &&
      data?.status !== "DENIED"
    ) {
      logout();

      history.push("/login", {
        unauthenticated: true,
      });
    }

    return Promise.reject(error);
  }
);

export default API;
